import React from 'react';
import DetectionGroupContext from '.';
import { useGetLiveSessionQuery } from '../../../../../generated/core-api/graphql-react-query';
import useLiveContext from '../../../../LiveContext/useLiveContext';
import useDetectionVisibility from './Hooks/useDetectionVisibility';

interface DetectionBadgeContextProviderProps {
  children: React.ReactNode;
  tab: { index: number, updatedAt: number };
}

export default function DetectionBadgeContextProvider(props: DetectionBadgeContextProviderProps) {
  const { children, tab } = props;
  const { sessionState: { latestDetection, session: basicSessionInfo } } = useLiveContext();
  const session = useGetLiveSessionQuery({ input: { id: basicSessionInfo?.id ?? '' } }, { enabled: !!basicSessionInfo });
  const detections = React.useMemo(() => session.data?.getSession.detections.filter((detection) => !!detection.cardId), [session.data?.getSession.detections]);

  React.useEffect(() => {
    if (latestDetection) {
      if (latestDetection && !!basicSessionInfo) {
        session.refetch();
      }
    }
  }, [latestDetection, !!basicSessionInfo, session.refetch]);
  const value = useDetectionVisibility(detections, tab, latestDetection);
  return (
    <DetectionGroupContext.Provider value={value}>
      {children}
    </DetectionGroupContext.Provider>
  );
}
